$(document).ready(function() {
    if ($('.DellavitaPage').length) {
        // ==================================   Variables =============================================

        var menuStatus = { open: true, close: false };
        var mainMenuClass = '.fullscreen-menu';
        var productsMenuClass = '.products-menu';

        // ==================================   Handlers =============================================

        $(window).scroll(function() {
            if ($(window).scrollTop() > 150) {
                $('.overlay').addClass('blur');
            } else {
                $('.overlay').removeClass('blur');
            }
        });

        $(window).resize(function() {
            toggleProductsMenu();
        });

        $('.header nav .menu').click(function() {
            toggleMenu(menuStatus.open);
        });

        $(mainMenuClass + ' .close').click(function() {
            toggleMenu(menuStatus.close);
        });

        $(mainMenuClass + ' a').click(function(e) {
            e.preventDefault();
            scrollToHash(this);

            toggleMenu(menuStatus.close);
        });

        $('h2').each(function() {
            var e,
                o = '<span class="first-word">',
                c = '</span>';

            e = $(this)
                .text()
                .split(' ');

            e.unshift(o);

            e.splice(2, 0, c);

            e = e.join(' ');

            $(this).html(e);
        });

        $(productsMenuClass + ' a').click(function() {
            var inclusionID = $(this).attr('data-target');

            $(productsMenuClass + ' a')
                .not($(this))
                .removeClass('show');
            $(this).toggleClass('show');

            if ($(this).hasClass('show')) {
                $('.inclusion-container').fadeOut();
                $('div[data-id="' + inclusionID + '"]')
                    .delay(500)
                    .fadeIn();
            } else {
                $('.inclusion-container').fadeOut();
            }
        });

        //Packages Modal
        $('.product').click(function() {
            var inclusionID = $(this).data('id');

            if (inclusionID) {
                var path = window.location.pathname != '/' ? window.location.pathname : '/home/';
                $.ajax({
                    url: window.location.origin + path + 'inclusionFeed/' + inclusionID,
                    success: function(result) {
                        var $result = JSON.parse(result);
                        if ($result.success) {
                            var $modalBody = $('#productModal .modal-body');
                            var $content = $('<div />')
                                .html($result.data.content)
                                .text();

                            $modalBody.empty();
                            $('#productModal .modal-title').html($result.data.title);
                            $modalBody.html($content);

                            $('.slick-slider').not('.slick-initialized').slick({
                                autoplay: true,
                                arrows: true,
                                infinite: true,
                                speed: 500,
                                fade: true,
                                pauseOnHover: true,
                                variableHeight: true
                            });

                            $('#productModal').modal({
                                keyboard: false
                            });
                        }
                    }
                });
            }
        });

        //Gallery Modal
        $('.gallery-images .image-container a').click(function() {
            var $modalBody = $('#productModal .modal-body');
            var $content = $('<div />').html('<img src="' + $(this).attr('data-src') + '" />');
            $modalBody.empty();
            $('#productModal .modal-title').html($(this).attr('data-title'));
            $modalBody.html($content);

            $('#productModal').modal({
                keyboard: false
            });
        });

        // ==================================  Functions =============================================

        function toggleProductsMenu() {
            if ($(window).width() <= 992) {
                $(productsMenuClass + '-ddl').addClass('dropdown-menu');
                $(productsMenuClass + '-ddl a').addClass('dropdown-item');
            } else {
                $(productsMenuClass + '-ddl').removeClass('dropdown-menu');
                $(productsMenuClass + '-ddl a').removeClass('dropdown-item');

                //not sure if I want this, fixes bug with products menu inline styling not being removed when resize window
                //setTimeout(function(){ $(productsMenuClass + '-ddl').attr('style','') }, 200);
            }
        }

        function toggleMenu(status) {
            if (status == menuStatus.open) {
                $('.header nav .menu').fadeOut(800);
                $('.box-container').animate({ opacity: 0 }, 800);
            } else {
                $('.header nav .menu').fadeIn(800);
                $('.box-container').animate({ opacity: 1 }, 800);
            }

            $(mainMenuClass).fadeToggle(500);
        }

        //Smooth Scrolling to anchors
        function scrollToHash(obj) {
            if (
                location.pathname.replace(/^\//, '') == obj.pathname.replace(/^\//, '') &&
                location.hostname == obj.hostname
            ) {
                var target = $(obj.hash);
                target = target.length ? target : $('[id=' + obj.hash.slice(1) + ']');

                if (target.length) {
                    $('html,body').animate({ scrollTop: target.offset().top - 200 }, 1500);
                    return false;
                }
            }
        }

        function init() {
            $(productsMenuClass + ' a:first-child').click();
            $('form .btn-primary').text('Send Enquiry');
        }

        // ==================================   Init =============================================

        init();
    } //end DellaVitaPage if
});
